import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

import { TranslatePipe } from 'app/core/i18n/translate.pipe';

// Aviso de documento generado: el snackbar de HandlerMessageService muestra texto
// plano, y aquí los seriales van resaltados
@Component({
  selector: 'app-document-created-snackbar',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, MatTooltipModule, TranslatePipe],
  templateUrl: './document-created-snackbar.component.html',
  styleUrl: './document-created-snackbar.component.scss',
})
export class DocumentCreatedSnackbarComponent {
  copied = false;

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: { message: string; serials?: string[] },
    private snackBarRef: MatSnackBarRef<DocumentCreatedSnackbarComponent>
  ) {}

  // los seriales se copian separados por coma, listos para pegar
  copySerials(): void {
    const text = (this.data.serials ?? []).join(',');
    if (!text) return;
    // el portapapeles falla sin permiso o fuera de contexto seguro: el aviso se
    // queda como está y el usuario copia el serial a mano
    navigator.clipboard
      ?.writeText(text)
      .then(() => (this.copied = true))
      .catch(() => (this.copied = false));
  }

  close(): void {
    this.snackBarRef.dismiss();
  }
}
